import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV } from '@app/constants/global.constants';
import { Env } from '@app/types/env';
import { EdmsError } from '@app/types/error';
import { AwsCredentialsDTO } from '@data/models/aws-credentials-dto';
import { AwsS3Client } from '../utils/aws-s3-client';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { S3Client } from '@aws-sdk/client-s3';

@Injectable({
  providedIn: 'root'
})
export class AwsS3StorageService {
  private readonly GET_AWS_CREDENTIALS = '/api/awsStorage/getCredentials';

  constructor(@Inject(ENV) private env: Env, private http: HttpClient) {}

  public getClient(): Observable<AwsS3Client> {
    return this.http.get<AwsCredentialsDTO>(`${this.env.apiBaseUrl}${this.GET_AWS_CREDENTIALS}`).pipe(
      map((credentials) => {
        const s3Client = new S3Client({
          region: credentials.region,
          credentials: {
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
          },
        });

        return new AwsS3Client(credentials.bucketName, s3Client);
      }),
      catchError((error) => throwError(error as EdmsError))
    );
  }
}
